import type { SearchMode } from '../types';

export const LEXICAL_SEARCH_TYPE: SearchMode = 'lexical';
export const NLP_SEARCH_TYPE: SearchMode = 'nlp';
